<template>
    <v-content class="page panel-owner" width="1222px">
        <v-container fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" md="12" class="top-container">
                    <v-card class="fill-width table_theme card-theme custom-container">
                        <v-card-title class="medium-font" style="letter-spacing: normal">
                            <h2 class="medium-font billing-title">
                                <span style="font-weight: 500 !important; color: #041332 !important;">Welcome, </span>
                                <strong style="font-weight: 600 !important;">{{ current_user.first_name }}</strong>
                            </h2>
                            <!--<v-spacer></v-spacer>-->
                            <!--<div-->
                                    <!--class="custom-o-search-bar"-->
                                    <!--style=""-->
                            <!--&gt;-->
                                <!--<v-text-field-->
                                        <!--placeholder="Search..."-->
                                        <!--single-line-->
                                        <!--hide-details-->
                                        <!--class="input_search"-->
                                        <!--color="#198beb"-->
                                        <!--width="316px"-->
                                <!--&gt;-->
                                    <!--<img-->
                                            <!--:src="require('@/assets/img/search.svg')"-->
                                            <!--slot="prepend"-->
                                            <!--alt="help"-->
                                            <!--class="info-tooltip"-->
                                    <!--/>-->
                                <!--</v-text-field>-->
                            <!--</div>-->
                            <!--<v-btn-->
                                    <!--text-->
                                    <!--class="custom-o-sliders"-->
                                    <!--style="position: relative;top: 5px; left: 20px"-->
                            <!--&gt;-->
                                <!--<img :src="require('@/assets/img/settings.svg')" alt/>-->
                            <!--</v-btn>-->
                        </v-card-title>
                        <v-divider class="mt-1" style="max-width: 1096px"></v-divider>

                        <!-- Owner onboarding / health card. Renders only for
                             tenant owners with a valid onboarding doc. The
                             store action calls /v1/onboarding/status and
                             swallows 403s for non-owners, so non-owners
                             simply see no card here. -->
                        <div v-if="onboardingStatus" class="onboarding-card-wrapper">
                          <!-- During onboarding: progress card with App
                               Store + Google Play badges. No "Continue"
                               button, no deep link. -->
                          <div
                              v-if="!onboardingStatus.completed_at"
                              class="onboarding-card onboarding-progress"
                          >
                            <div class="onboarding-card__header">
                              <h3 class="onboarding-card__title">Setup in progress</h3>
                              <p class="onboarding-card__subtitle">
                                {{ stepsCompleted }} of 2 steps complete
                              </p>
                            </div>

                            <ul class="onboarding-card__steps">
                              <li class="onboarding-step">
                                <span
                                    class="onboarding-step__check"
                                    :class="{ 'is-checked': agentsCompleted }"
                                >&#10003;</span>
                                <span class="onboarding-step__label">
                                  Agents
                                </span>
                                <span class="onboarding-step__count">
                                  {{ agentsInvited }} invited
                                </span>
                              </li>
                              <li class="onboarding-step">
                                <span
                                    class="onboarding-step__check"
                                    :class="{ 'is-checked': vendorsCompleted }"
                                >&#10003;</span>
                                <span class="onboarding-step__label">
                                  Vendors
                                </span>
                                <span class="onboarding-step__count">
                                  {{ vendorsInvited }} / {{ vendorsMin }} invited
                                </span>
                              </li>
                            </ul>

                            <div class="onboarding-card__footer">
                              <p class="onboarding-card__cta">
                                Download the Kiey app on your phone to add
                                your team and run your business.
                              </p>
                              <div class="onboarding-card__badges">
                                <a
                                    :href="appleStoreUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="onboarding-card__badge-link"
                                    aria-label="Download on the App Store"
                                >
                                  <img
                                      :src="require('@/assets/img/apple_store.svg')"
                                      alt="Download on the App Store"
                                      class="onboarding-card__badge"
                                  />
                                </a>
                                <a
                                    :href="googlePlayUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="onboarding-card__badge-link"
                                    aria-label="Get it on Google Play"
                                >
                                  <img
                                      :src="require('@/assets/img/google_play.svg')"
                                      alt="Get it on Google Play"
                                      class="onboarding-card__badge"
                                  />
                                </a>
                              </div>
                            </div>
                          </div>

                          <!-- After completion: account health card with a
                               progress circle (red < 0.34 / yellow < 0.67 /
                               green) computed using the same formula as
                               iOS. -->
                          <div
                              v-else
                              class="onboarding-card onboarding-health"
                          >
                            <div class="onboarding-health__header">
                              <h3 class="onboarding-card__title">Account Health</h3>
                            </div>

                            <div class="onboarding-health__body">
                              <div class="onboarding-health__circle-wrap">
                                <svg
                                    class="onboarding-health__circle"
                                    viewBox="0 0 120 120"
                                    width="120"
                                    height="120"
                                    aria-hidden="true"
                                >
                                  <circle
                                      class="onboarding-health__circle-bg"
                                      cx="60"
                                      cy="60"
                                      r="52"
                                  />
                                  <circle
                                      class="onboarding-health__circle-fg"
                                      :style="{ stroke: healthColor }"
                                      cx="60"
                                      cy="60"
                                      r="52"
                                      :stroke-dasharray="healthCircumference"
                                      :stroke-dashoffset="healthDashOffset"
                                  />
                                </svg>
                                <div
                                    class="onboarding-health__pct"
                                    :style="{ color: healthColor }"
                                >
                                  {{ healthPctLabel }}
                                </div>
                              </div>

                              <ul class="onboarding-health__categories">
                                <li class="onboarding-health__category">
                                  <span class="onboarding-health__category-label">Vendors</span>
                                  <span class="onboarding-health__category-value">
                                    {{ vendorsActive }} / {{ vendorsActiveTarget }} active
                                  </span>
                                </li>
                                <li class="onboarding-health__category">
                                  <span class="onboarding-health__category-label">Homeowners</span>
                                  <span class="onboarding-health__category-value">
                                    {{ homeownersActive }} / {{ homeownersTarget }} active
                                  </span>
                                </li>
                                <li class="onboarding-health__category">
                                  <span class="onboarding-health__category-label">Agents</span>
                                  <span class="onboarding-health__category-value">
                                    {{ agentsHealthLabel }}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <v-card-text>
                            <div class="mt-1 ml-2 pb-8 cont-admin_cards" style="margin-right: 44px;">
                                <div @click="$router.push('/owner/users')" class="cont-admin_cards__item colors-a">
                                    <div class="cont-admin_cards__container">
                                        <h4 class="cont-admin_cards__title">Agents</h4>
                                        <p class="cont-admin_cards__text">
                                            Manage your agent list. Add, Edit, Delete and
                                            view details of your current user accounts.
                                        </p>
                                        <a @click="$router.push('/owner/users')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt/>
                                        </a>
                                    </div>
                                </div>

                                <div
                                        @click="$router.push('/owner/vendors')"
                                        class="cont-admin_cards__item cont-admin_cards__item--b colors-c"
                                >
                                    <div class="cont-admin_cards__container color2">
                                        <h4 class="cont-admin_cards__title">Vendors</h4>
                                        <p class="cont-admin_cards__text">
                                            Manage your vendor list. Add more vendors
                                            <br/>to give increased benefit to your homeowners.
                                        </p>
                                        <a @click="$router.push('/owner/vendors')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-black.svg')" alt/>
                                        </a>
                                    </div>
                                </div>

                                <div
                                        @click="$router.push('/owner/clients')"
                                        class="cont-admin_cards__item colors-e"
                                >
                                    <div class="cont-admin_cards__container">
                                        <h4 class="cont-admin_cards__title">Homeowners</h4>
                                        <p
                                                class="cont-admin_cards__text"
                                        >
                                            View and analyze the health of your homeowners. Easily sort, manage and message homeowners via push notifications.</p>
                                        <a @click="$router.push('/owner/clients')" href class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt/>
                                        </a>
                                    </div>
                                </div>

                                <div
                                        @click="$router.push('/owner/marketing')"
                                        class="cont-admin_cards__item cont-admin_cards__item--b colors-b"
                                >
                                    <div class="cont-admin_cards__container color2">
                                        <h4 class="cont-admin_cards__title">Marketing</h4>
                                        <p class="cont-admin_cards__text">
                                            Watch the pages where homeowners ask for help, draft AI replies with tracked links, and create sign-up source links.
                                        </p>
                                        <a @click="$router.push('/owner/marketing')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-black.svg')" alt/>
                                        </a>
                                    </div>
                                </div>

<!--                                <div-->
<!--                                        @click="$router.push('/owner/reports')"-->
<!--                                        class="cont-admin_cards__item cont-admin_cards__item&#45;&#45;b colors-b"-->
<!--                                >-->
<!--                                    <div class="cont-admin_cards__container color2">-->
<!--                                        <h4 class="cont-admin_cards__title">Reports</h4>-->
<!--                                        <p-->
<!--                                                class="cont-admin_cards__text"-->
<!--                                        >-->
<!--                                            Analyze your vendor & client engagements through advanced search and filter capabilities</p>-->
<!--                                        <a @click="$router.push('/owner/reports')" class="cont-admin_cards__icon">-->
<!--                                            <img :src="require('@/assets/img/dash-box-arrow-black.svg')" alt/>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                </div>-->

                                <div
                                        @click="$router.push('/owner/vendor-recommendations')"
                                        class="cont-admin_cards__item colors-g"
                                        style="position: relative;"
                                >
                                    <div v-if="pendingRecommendationsCount > 0"
                                         style="position: absolute; top: 12px; right: 12px; background: #F44336; color: white; border-radius: 12px; min-width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; padding: 0 6px;">
                                        {{ pendingRecommendationsCount }}
                                    </div>
                                    <div class="cont-admin_cards__container">
                                        <h4 class="cont-admin_cards__title">Vendor Recommendations</h4>
                                        <p class="cont-admin_cards__text">
                                            Review vendor recommendations from your network.
                                        </p>
                                        <a @click="$router.push('/owner/vendor-recommendations')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt/>
                                        </a>
                                    </div>
                                </div>

                                <div
                                        @click="$router.push('/owner/vendor-coverage')"
                                        class="cont-admin_cards__item cont-admin_cards__item--b colors-h"
                                >
                                    <div class="cont-admin_cards__container color2">
                                        <h4 class="cont-admin_cards__title">Vendor Coverage</h4>
                                        <p class="cont-admin_cards__text">
                                            See which service categories you have covered and where your gaps are.
                                        </p>
                                        <a @click="$router.push('/owner/vendor-coverage')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-black.svg')" alt/>
                                        </a>
                                    </div>
                                </div>

                                <div
                                        @click="$router.push('/owner/invited-users')"
                                        class="cont-admin_cards__item cont-admin_cards__item--b colors-i"
                                        v-if="user.user_role === 'super_user'"
                                >
                                    <div class="cont-admin_cards__container color2">
                                        <h4 class="cont-admin_cards__title">Invited Users</h4>
                                        <p class="cont-admin_cards__text">
                                            Track users invited through the referral
                                            <br/>program and their registration status.
                                        </p>
                                        <a @click="$router.push('/owner/invited-users')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-black.svg')" alt/>
                                        </a>
                                    </div>
                                </div>

                                <div
                                        @click="$router.push('/owner/account')"
                                        class="cont-admin_cards__item colors-d"
                                        v-if="user.user_role !== 'super_user'"
                                >
                                    <div class="cont-admin_cards__container" >
                                        <h4 class="cont-admin_cards__title">Account</h4>
                                        <p
                                                class="cont-admin_cards__text"
                                        >Manage your company details and account.</p>
                                        <a @click="$router.push('/owner/account')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt/>
                                        </a>
                                    </div>
                                </div>

                                <div
                                        @click="$router.push('/owner/supports')"
                                        class="cont-admin_cards__item colors-f"
                                        v-if="user.user_role !== 'super_user'"
                                >
                                    <div class="cont-admin_cards__container">
                                        <h4 class="cont-admin_cards__title">Support</h4>
                                        <p class="cont-admin_cards__text">
                                            Have a question you need answered?
                                            <br/>Message us here.
                                        </p>
                                        <a @click="$router.push('/owner/supports')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt/>
                                        </a>
                                    </div>
                                </div>
                                <div
                                        @click="$router.push('/owner/tenants')"
                                        class="cont-admin_cards__item colors-c"
                                        v-if="user.user_role === 'super_user'"
                                >
                                    <div class="cont-admin_cards__container color2">
                                        <h4 class="cont-admin_cards__title">Tenants</h4>
                                        <p class="cont-admin_cards__text">
                                            Platform-wide tenant health: orphans, role mismatches,
                                            <br/>billing anomalies, and user coverage.
                                        </p>
                                        <a @click="$router.push('/owner/tenants')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-black.svg')" alt/>
                                        </a>
                                    </div>
                                </div>
                                <div
                                        @click="$router.push('/owner/sms-logs')"
                                        class="cont-admin_cards__item colors-a"
                                        v-if="user.user_role === 'super_user'"
                                >
                                    <div class="cont-admin_cards__container">
                                        <h4 class="cont-admin_cards__title">SMS</h4>
                                        <p class="cont-admin_cards__text">
                                            View SMS logs, search by user or phone number, filter by date range, and export records.
                                        </p>
                                        <a @click="$router.push('/owner/sms-logs')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt/>
                                        </a>
                                    </div>
                                </div>
                                <div
                                        @click="$router.push('/owner/app-version-management')"
                                        class="cont-admin_cards__item colors-d"
                                        v-if="user.user_role === 'super_user'"
                                >
                                    <div class="cont-admin_cards__container">
                                        <h4 class="cont-admin_cards__title">App Version Management</h4>
                                        <p class="cont-admin_cards__text">
                                            Manage iOS &amp; Android update thresholds for soft and forced update prompts.
                                        </p>
                                        <a @click="$router.push('/owner/app-version-management')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt/>
                                        </a>
                                    </div>
                                </div>
                                <div
                                        @click="$router.push('/owner/marketing-console')"
                                        class="cont-admin_cards__item colors-b"
                                        v-if="user.user_role === 'super_user'"
                                >
                                    <div class="cont-admin_cards__container color2">
                                        <h4 class="cont-admin_cards__title">Marketing Console</h4>
                                        <p class="cont-admin_cards__text">
                                            Pick any team and manage its marketing — watched pages, screenshot replies, dashboard, and sign-up links.
                                        </p>
                                        <a @click="$router.push('/owner/marketing-console')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-black.svg')" alt/>
                                        </a>
                                    </div>
                                </div>
                                <div
                                        @click="$router.push('/owner/signup-waitlist')"
                                        class="cont-admin_cards__item colors-d"
                                        v-if="user.user_role === 'super_user'"
                                >
                                    <div class="cont-admin_cards__container">
                                        <h4 class="cont-admin_cards__title">Sign-Up Waitlist</h4>
                                        <p class="cont-admin_cards__text">
                                            View self-service sign-up requests from vendors and clients, and users needing an agent in their area. Matched requests go straight to each team's Referrals.
                                        </p>
                                        <a @click="$router.push('/owner/signup-waitlist')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt/>
                                        </a>
                                    </div>
                                </div>
                                <div
                                        @click="$router.push('/owner/onboarding')"
                                        class="cont-admin_cards__item colors-d"
                                        v-if="user.user_role === 'super_user'"
                                >
                                    <div class="cont-admin_cards__container">
                                        <h4 class="cont-admin_cards__title">Onboarding Tracker</h4>
                                        <p class="cont-admin_cards__text">
                                            Track each team's onboarding funnel — all agents first, then 40 vendors, then 100 homeowners — with live counts, next actions, meetings, and updates.
                                        </p>
                                        <a @click="$router.push('/owner/onboarding')" class="cont-admin_cards__icon">
                                            <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt/>
                                        </a>
                                    </div>
                                </div>
                                <div class="cont-admin_cards__item colors-transparent"></div>
                            </div>
                        </v-card-text>
                        <div class="sombra"></div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>

<script>
    import {mapGetters} from "vuex";
    import {mapState} from "vuex";

    export default {
        name: "Login",
        created() {
            this.$store.dispatch("Banner/show");
            this.$store.dispatch("Referral_engine/fetchRecommendations", "pending");
            // Onboarding card — backend gates this owner-only, non-owners get
            // a 403 (handled silently in the store action) so this is safe to
            // dispatch unconditionally for any logged-in user landing here.
            this.$store.dispatch("Onboarding/fetchStatus");
        },
        data: () => ({
            search: "",
            phoneNumber: "",
            email: "",
            // Health circle radius/circumference precomputed for SVG dash math.
            healthCircumference: 2 * Math.PI * 52,
        }),
        computed: {
            ...mapGetters({current_user: ["Authenticate/current_user"]}),
            appleStoreUrl() {
                return this.$store.getters["Authenticate/getAppleStoreUrl"];
            },
            googlePlayUrl() {
                return this.$store.getters["Authenticate/getGooglePlayUrl"];
            },
            ...mapState({
                user: state => state.Authenticate.user,
                pendingRecommendationsCount: state => {
                    const recs = (state.Referral_engine && state.Referral_engine.recommendations) || [];
                    return recs.filter(r => r.status === 'pending').length;
                },
                onboardingStatus: state => state.Onboarding && state.Onboarding.status,
                // Tenant switch on this app goes through Authenticate/activate_ut
                // which calls /login and commits auth_success — that replaces
                // state.Authenticate.user with the new tenant's user (and its
                // tenant_id). The watcher below keys on this so the Account
                // Health and onboarding-progress cards re-fetch on switch.
                // (state.Chat.tenant_id is only updated by the legacy
                // SwitchAccount component, which this admin panel doesn't use.)
                tenantId: state => state.Authenticate.user && state.Authenticate.user.tenant_id,
            }),
            agentsCompleted() {
                const a = this.onboardingStatus && this.onboardingStatus.agents;
                return !!(a && a.completed_at);
            },
            vendorsCompleted() {
                const v = this.onboardingStatus && this.onboardingStatus.vendors;
                return !!(v && v.completed_at);
            },
            stepsCompleted() {
                return (this.agentsCompleted ? 1 : 0) + (this.vendorsCompleted ? 1 : 0);
            },
            agentsInvited() {
                const a = this.onboardingStatus && this.onboardingStatus.agents;
                return (a && a.invited_count) || 0;
            },
            vendorsInvited() {
                const v = this.onboardingStatus && this.onboardingStatus.vendors;
                return (v && v.invited_count) || 0;
            },
            vendorsMin() {
                const v = this.onboardingStatus && this.onboardingStatus.vendors;
                return (v && v.min) || 0;
            },
            // Health-card derived values — only meaningful once
            // onboardingStatus.completed_at is populated.
            health() {
                return (this.onboardingStatus && this.onboardingStatus.health) || null;
            },
            vendorsActive() {
                return (this.health && this.health.vendors_active) || 0;
            },
            vendorsActiveTarget() {
                return (this.health && this.health.vendors_target) || 40;
            },
            homeownersActive() {
                return (this.health && this.health.homeowners_active) || 0;
            },
            homeownersTarget() {
                return (this.health && this.health.homeowners_target) || 100;
            },
            agentsHealthLabel() {
                const a = this.onboardingStatus && this.onboardingStatus.agents;
                if (a && a.no_more_tapped) return "All set";
                const target = (a && a.target_count) || 0;
                if (target > 0) {
                    return `${this.agentsInvited} invited / ${target} target`;
                }
                return `${this.agentsInvited} invited`;
            },
            // Health pct + colour are now computed server-side by
            // functions/api/util/account_health.js and returned in the
            // GET /v1/onboarding/status response. We just read them here.
            healthPct() {
                return (this.health && typeof this.health.pct === "number") ? this.health.pct : 0;
            },
            healthPctLabel() {
                return `${Math.round(this.healthPct * 100)}%`;
            },
            healthColor() {
                return (this.health && this.health.color) || "#E53935";
            },
            healthDashOffset() {
                return this.healthCircumference * (1 - this.healthPct);
            },
        },
        watch: {
            // Re-fetch onboarding status when the user switches tenants —
            // Authenticate/activate_ut calls /login and commits auth_success
            // which replaces state.Authenticate.user (and its tenant_id).
            // Without this the Account Health and onboarding-progress cards
            // keep showing the previous tenant's numbers, color, and pct.
            tenantId(next, prev) {
                if (!next || next === prev) return;
                this.$store.dispatch("Onboarding/clear");
                this.$store.dispatch("Onboarding/fetchStatus");
            },
        },
        components: {},
        methods: {},
    };
</script>

<style lang="scss">
    .panel-owner {
        .custom-container {
            max-width: 1222px !important;
            min-height: 558px;
            margin-bottom: 50px !important;
        }

        /* estilo para pregunta */
        .azul {
            color: #000000;
            font-size: 16px;
            font-weight: 400;
            letter-spacing: -0.31px;
            margin-right: 11px;
        }

        /* estilo para link ContactUs*/
        .azul-contact {
            font-size: 15px;
            font-weight: 700;
        }

        /* estilo para texto debajo de login */
        .v-application .py-2 {
            color: #878787;
            font-size: 15px;
            font-weight: 500;
        }

        .btn-t {
            width: 155px;
            height: 48px;
            color: white;
            box-shadow: 0 5px 18px rgba(51, 51, 51, 0.13);
            border-radius: 24px;
            margin: 0 auto;
        }

        .ui-label {
            color: #061d47;
            /*!important;*/
            font-size: 20px !important;
            font-weight: bold !important;
        }

        .padd-log {
            padding: 0 65px;
        }

        .card-theme {
            -webkit-box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.1) !important;
            -moz-box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.1) !important;
            box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.1) !important;
        }

        .v-input__control {
            width: 34px;
        }

        .fa-theme--a {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #29abe2;
            font-size: 10px !important;
        }

        @media (max-width: 768px) {
            .v-application .px-10 {
                padding-left: 0px !important;
                padding-right: 0px !important;
            }

            .padd-log {
                padding: 0;
            }
        }
        @media (max-width: 450px) {
            .cont-admin_cards__item {
                height: auto;
            }
            .v-card__title {
                padding: 0;
            }
        }
    }
</style>

<style scoped>
/* Onboarding / health card. Plain HTML markup, plain CSS — kept separate
   from the Vuetify SCSS above. Sits between the welcome title and the
   admin cards grid. */
.onboarding-card-wrapper {
    padding: 16px 24px 0 24px;
    box-sizing: border-box;
}

.onboarding-card {
    background-color: #ffffff;
    border: 1px solid #e3e7f1;
    border-radius: 10px;
    padding: 20px 24px;
    box-shadow: 0 4px 12px rgba(6, 29, 71, 0.04);
}

.onboarding-card__header {
    margin-bottom: 12px;
}

.onboarding-card__title {
    color: #061d47;
    font-family: "Roboto-Medium", Arial, sans-serif;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 4px 0;
}

.onboarding-card__subtitle {
    color: #6a6a6a;
    font-family: Arial, sans-serif;
    font-size: 14px;
    margin: 0;
}

.onboarding-card__steps {
    list-style: none;
    padding: 0;
    margin: 0 0 16px 0;
}

.onboarding-step {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #f1f3f8;
}

.onboarding-step:last-child {
    border-bottom: none;
}

.onboarding-step__check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: #e3e7f1;
    color: transparent;
    font-size: 14px;
    font-weight: 700;
    margin-right: 12px;
    flex-shrink: 0;
}

.onboarding-step__check.is-checked {
    background-color: #43a047;
    color: #ffffff;
}

.onboarding-step__label {
    color: #061d47;
    font-family: Arial, sans-serif;
    font-size: 15px;
    font-weight: 500;
    flex: 1 1 auto;
}

.onboarding-step__count {
    color: #4a4a4a;
    font-family: Arial, sans-serif;
    font-size: 14px;
    flex-shrink: 0;
}

.onboarding-card__footer {
    border-top: 1px solid #f1f3f8;
    padding-top: 16px;
    margin-top: 4px;
}

.onboarding-card__cta {
    color: #4a4a4a;
    font-family: Arial, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    margin: 0 0 12px 0;
}

.onboarding-card__badges {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.onboarding-card__badge-link {
    display: inline-block;
    text-decoration: none;
    line-height: 0;
}

.onboarding-card__badge {
    height: 40px;
    width: auto;
    display: block;
}

/* --- Health card --- */
.onboarding-health__header {
    margin-bottom: 16px;
}

.onboarding-health__body {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 32px;
}

.onboarding-health__circle-wrap {
    position: relative;
    width: 120px;
    height: 120px;
    flex-shrink: 0;
}

.onboarding-health__circle {
    transform: rotate(-90deg);
    display: block;
}

.onboarding-health__circle-bg {
    fill: none;
    stroke: #f1f3f8;
    stroke-width: 10;
}

.onboarding-health__circle-fg {
    fill: none;
    stroke-width: 10;
    stroke-linecap: round;
    transition: stroke-dashoffset 0.4s ease, stroke 0.4s ease;
}

.onboarding-health__pct {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Roboto-Medium", Arial, sans-serif;
    font-size: 22px;
    font-weight: 600;
}

.onboarding-health__categories {
    list-style: none;
    padding: 0;
    margin: 0;
    flex: 1 1 220px;
    min-width: 200px;
}

.onboarding-health__category {
    display: flex;
    align-items: center;
    padding: 6px 0;
}

.onboarding-health__category-label {
    color: #061d47;
    font-family: Arial, sans-serif;
    font-size: 15px;
    font-weight: 500;
    flex: 1 1 auto;
}

.onboarding-health__category-value {
    color: #4a4a4a;
    font-family: Arial, sans-serif;
    font-size: 14px;
    flex-shrink: 0;
}

@media (max-width: 600px) {
    .onboarding-card-wrapper {
        padding: 12px 16px 0 16px;
    }

    .onboarding-card {
        padding: 16px;
    }

    .onboarding-health__body {
        gap: 16px;
    }
}
</style>
